import React, { useCallback } from 'react';
import { FormGroup, FormSelect } from '~/components/form';
import { ownerEntityType } from '~/api';
import { useForm } from '~/hooks';


export const OwnerEntity= (props) => {

    const {
        onOwnerIndividualChange,
        detailData
    } = props;

    const defaultState = {
        ownerEntityName: detailData? detailData.ownerEntityName : '',
        ownerEntityType: detailData? detailData.ownerEntityType : { label: '...', value: '' }
    };

    const loadData = () => async (values) => {
        const ownerEntityTypeOptions = (await ownerEntityType.getOwnerEntityTypes()).map(f => ({
            label: f.label, value: f.value
        }));
        return {
            ...values,
            ownerEntityTypeOptions
        };
    };
    
    const onLoad = useCallback(loadData(), []);

    const { state, fieldActions } = useForm({
        initialState: { ...defaultState },
        onLoad
    });

    return (
        <div className="row grid grid-cols-4 grid-flow-row gap-x-2 gap-y-4 text-sm mb-4">  
            <FormGroup
                label="Entity Name"
                required
                groupClassName="col-span-2"
                inputClassName="w-full border-1 border-gray-200 rounded bg-gray-50"
                path='ownerEntityName'
                maxLength={36}
                validator={value=> value.length < 36 ? true : state.values.ownerEntityName && 'Limit to 36 characters.'}                
                value={state.values.ownerEntityName}
                error={state.errors.ownerEntityName}
                {...fieldActions}
                onChange={(value) => {
                    fieldActions.onChange(value, 'ownerEntityName');   
                    onOwnerIndividualChange(state.values);                 
                }}
            />
            <FormSelect
                label="Entity Type"
                type='select'
                required
                options={state.values.ownerEntityTypeOptions}
                isClearable={false}
                isSearchable
                groupClassName="col-span-2"
                className="w-full border-1 border-gray-200 rounded bg-gray-50"
                path='ownerEntityType'   
                value={state.values.ownerEntityType}
                error={state.errors.ownerEntityType}
                {...fieldActions}
                onChange={(ownerEntityType) => {
                    fieldActions.onChange(ownerEntityType, 'ownerEntityType');
                    fieldActions.onChange({ label: '...', value: ''}, 'requestedBy');  
                    onOwnerIndividualChange(state.values);                      
                }}                             
            />     
        </div>
    );
};
